export default __webpack_public_path__ + "static/media/p.0f755358.mp4";